import {css} from 'lit';
export const styles = css`:host {
  --padding-block: 20px;
  --padding-inline: 26px;

  display: block;
}

::slotted(h2) {
  margin: 0;
}

header {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 235px;
  overflow: hidden;
  color: var(--contrast-light);
}

header::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-image: linear-gradient(
      180deg,
      rgb(var(--contrast-dark-rgb), 0) 0%,
      rgb(var(--contrast-dark-rgb), 0.65) 100%
    );
  }

header > img {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    -o-object-fit: cover;
       object-fit: cover;
    z-index: 0;
  }

header > div,
  header .favorite {
    z-index: 2;
    position: relative;
    padding: var(--padding-block) var(--padding-inline);
    display: flex;
  }

@media (max-width: 991px) {

header > div,
  header .favorite {
      padding: var(--padding-block) var(--page-padding-x)
  }
    }

header .favorite {
    flex: 1;
    justify-content: end;
    font-size: var(--font-size-xl);
  }

header > div:last-child > ef-img-placeholder {
      --element-size: 60px;

      flex-shrink: 0;
      margin-right: 16px;
      margin-top: 6px;
    }

header div.info-wrapper {
    display: flex;
  }

.info {
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-sm);
  justify-content: center;
}

.info > div:last-child {
    display: flex;
    margin-top: 4px;
  }

.info .xs-btn {
    margin-top: 6px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }

.info slot::slotted(.xs-title-2) {
    margin-bottom: 0 !important;
  }

ef-grid-list {
  margin-top: 4px;
}

ef-grid-list > * {
    position: relative;
    margin-right: 8px;
    padding-right: 8px;
  }

.icon-block {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
}

.icon-block ef-icon {
    margin-right: 8px;
  }

.members {
  white-space: nowrap;
}

.icon-block::after,
.members::after {
  content: '';
  position: absolute;
  display: inline-block;
  top: 0;
  left: 100%;
  height: 19px;
  width: 1px;
  background-color: var(--contrast-light);
  z-index: 10;
}

[name='origin']::slotted(xs-origin),
.members {
  --link-text: var(--contrast-light);
  --link-text-active: var(--primary-300);
  --link-text-hover: var(--teal-200);
}

@media (max-width: 991px) {
  slot[name='optional-left']::slotted(.xs-btn) {
    flex-grow: 1;
  }
}

.slot-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: var(--padding-block) var(--padding-inline);
  background-color: var(--contrast-light);
}

@media (max-width: 991px) {

.slot-wrapper {
    justify-content: space-between;
    background-color: transparent;
    padding: var(--padding-block) var(--page-padding-x)
}
  }

[name='optional-left']::slotted(*) {
  margin-right: 8px !important;
}

[name='optional-right'] {
  display: block;
  margin-left: auto;
}

[name='info']::slotted(*) {
  margin-left: var(--page-padding-x);
  margin-right: var(--page-padding-x);
  margin-bottom: 20px;
  display: block;
}

@media (min-width: 992px) {

[name='info']::slotted(*) {
    margin: 20px 0 0
}
  }
`;
export default styles;
